module.exports = __webpack_public_path__ + "static/img/index_1.4514ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_1.png
// module id = VDCJ
// module chunks = 1